import { db } from '../../utils/firebase';

export const getWomenInRobotics = async () => {
  const querySnapshot = db.collection("outreach").doc("womenInRobotics");
  const doc = await querySnapshot.get();
  const { content, image, frame_src, image_icra, intro } = doc.data();
  return { content, image, frame_src, image_icra, intro };
};

